CheckoutV2.PaymentV2.Models = function(checkout) {
    var models = this;

    this.creditCard = {
        number: null,
        expireMonth: null,
        expireYear: null,
        cvv: null,
        billing: null
    };

    this.creditCardFrom = function(number, expireMonth, expireYear, cvv, billing) {
        var copy = Object.create(models.creditCard);

        copy.number = number;
        copy.expireMonth = expireMonth;
        copy.expireYear = expireYear;
        copy.cvv = cvv;
        copy.billing = billing;

        return copy;
    };

    this.paymentReviewInfo = {
        method: null,
        method_name: null,
        card_type: null,
        card_last_four: null,
        card_expire_month: null,
        card_expire_year: null,
        first_name: null,
        last_name: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        payment_amount: null
    };

    this.paymentReviewFromPaymentMethod = function(card) {
        var copy = Object.create(models.paymentReviewInfo);

        if(card.method.indexOf('storedcreditcard-') !== -1){
            copy.method = 'creditcard';
            copy.method_name = 'Credit Card';
        } else if(card.method === 'creditcard') {
            copy.method = 'creditcard';
            copy.method_name = 'Credit Card';
        } else if(card.method === 'paypal'){
            copy.method = 'paypal';
            copy.method_name = 'PayPal';
        } else if(card.method === 'btpaypal'){
            copy.method = 'btpaypal';
            copy.method_name = 'PayPal';
        } else if(card.method === 'paypalrequest') {
            copy.method = 'paypalrequest';
            copy.method_name = 'Paypal Request';
        } else if(card.method === 'affirm'){
            copy.method = 'affirm';
            copy.method_name = 'Affirm';
        } else if(card.method === 'priorauth'){
            copy.method = 'priorauth';
            copy.method_name = 'Prior Authorization';
        } else if(card.method === 'wiretransfer') {
            copy.method = 'wiretransfer';
            copy.method_name = 'Wire Transfer';
        } else if(card.method === 'onaccount') {
            copy.method = 'onaccount';
            copy.method_name = 'On Account';
        } else {
            copy.method = 'UNKNOWN METHOD';
            copy.method_name = 'UNKNOWN NAME';
        }
        copy.card_type = card.type;
        copy.card_last_four = card.last_four;
        copy.card_expire_month = card.expire_month;
        copy.card_expire_year = card.expire_year;
        copy.first_name = card.first_name;
        copy.last_name = card.last_name;
        copy.address = card.address;
        copy.city = card.city;
        copy.state = card.state;
        copy.zip = card.zip;
        copy.payment_amount = card.payment_amount;
        if (card.email)
           copy.email = card.email;

        return copy;
    };

    this.paymentReviewFromBalanceMethod = function(method) {
        var copy = Object.create(models.paymentReviewInfo);

        if(method.type === 'rewards'){
            copy.method = 'storecredit';
            copy.method_name = 'Rewards';
        } else if(method.type === 'instore') {
            copy.method = 'storecredit';
            copy.method_name = 'In Store Credit';
        } else if(method.type === 'giftcard'){
            copy.method = 'storecredit';
            copy.method_name = 'Gift Cards';
        }

        copy.payment_amount = method.amount;

        return copy
    };

    this.billInfo = {
        address1: null,
        address2: null,
        city: null,
        company:null,
        country: null,
        email: null,
        firstname: null,
        lastname: null,
        phone: null,
        phone_alternate: null,
        phone_fax: null,
        state: null,
        zip: null
    };

    // Expects the session billing info object
    this.billInfoFromSession = function(billInfo) {
        var copy = Object.create(models.billInfo);

        copy = billInfo;

        return copy;
    };

	this.billInfoFromPayPal = function( billing ) {
		var copy = Object.create(models.billInfo);
		copy.address = billing.line1;
		copy.address2 = billing.line2;
		copy.state = billing.state;
		copy.city = billing.city;
		copy.zip = billing.postalCode;
		copy.country = billing.countryCode;
		return copy;
	};

    // Stamp a payment method with billing info
    this.setPaymentMethodBillInfo = function(paymentMethod, billInfo){
        paymentMethod.first_name = billInfo.firstname;
        paymentMethod.last_name = billInfo.lastname;
        paymentMethod.address = billInfo.address1;
        paymentMethod.city = billInfo.city;
        paymentMethod.state = billInfo.state;
        paymentMethod.zip = billInfo.zip;
        paymentMethod.billinfo = {};
    };

    this.paymentMethod = {
        id: null, // id from "storedcreditcard-219615896".split('-')[0]
        method: null, // payment method tag like "storedcreditcard-219615896" or "paypal"
        payment_amount: null, // payment amount for this method
        type: null, // cc type
        card_number: null, // cc full number
        last_four: null, // cc last 4
        expire_month: null, // cc exp month
        expire_year: null, // cc exp year
        cvv: null, // cc cvv
        first_name: null, // billing first name
        last_name: null, // billing last name
        address: null, // billing address1
        address2: null, // billing address2
        company: null, // billing company
        country: null, //billing country
        city: null, // billing city
        state: null, // billing state
        zip: null, // billing zip
        phone: null, // billing phone
        phone_alternate: null, // billing phone alternate
        phone_fax: null, // billing phone fax
        billID: null, // billing ID
        billinfo: {}, // billinfo object
        fee: 0, // payment fee, used for wire transfer
        authNum: '', // used for prior auth
        cardType: '', // used for prior auth
        amtInput: 0, // used for prior auth
        hostedFieldsInterface: null,
    };

    this.paymentMethodFromStoredCard = function(card, amount) {
        var copy = Object.create(models.paymentMethod);

        copy.id = card.method.split('storedcreditcard-')[1];
        copy.method = card.method;
        copy.payment_amount = parseFloat(amount);
        copy.type = card.cardType;
        copy.card_number = null;
        copy.last_four = card.cardLast4;
        copy.expire_month = ((card.expMonth + '').length == 1 ? '0' : '') + card.expMonth;
        copy.expire_year = (card.expYear + '').slice(-2);
        copy.cvv = null;
        copy.first_name = card.firstName;
        copy.last_name = card.lastName;
        copy.address = card.address;
        copy.address2 = card.address2;
        copy.city = card.city;
        copy.country = card.country;
        copy.state = card.state;
        copy.zip = card.zip;
        copy.billID = card.billID;
        copy.billinfo = {};
        copy.hostedFieldsInterface = card.hostedFieldsInterface;

        return copy;
    };

    this.paymentMethodFromStoredAccount = function(account, amount) {
        var copy = Object.create(models.paymentMethod);

        copy.id = account.method.split('storedcreditcard-')[1];
        copy.method = account.method;
        copy.payment_amount = parseFloat(amount);
        copy.type = account.cardType;
		copy.paypalEmail = account.paypalEmail;
		copy.paypalEmail = account.paypalEmail;
        copy.first_name = account.firstName;
        copy.last_name = account.lastName;
        copy.address = account.address;
        copy.address2 = account.address2;
        copy.city = account.city;
        copy.country = account.country;
        copy.state = account.state;
        copy.zip = account.zip;
        copy.billID = account.billID;
        copy.billinfo = {};

        return copy;
    };

    this.paymentMethodFromPaypal = function(data, amount) {
		var copy;
		if (data.nonce) {
			copy = JSON.parse( JSON.stringify( models.billInfoFromPayPal( data.billingAddress )));
        	copy.method = 'btpaypal';
			// verified / vaulted paypal
        	copy.payment_amount = parseFloat(amount);
			copy.nonce = data.nonce;
			copy.paypalEmail = data.email;
			copy.email = data.email;
			copy.payerID = data.payerID;
			copy.phone = data.phone;
			copy.first_name = data.first_name;
			copy.last_name = data.last_name;
			copy.paypalCredit = data.paypalCredit;
			copy.billinfo = {};
		} else {
			copy = { 
				method: 'btpaypal',
				payment_amount: parseFloat( amount ),
                paypalEmail: data.email,
				storedPaymentID: data.storedPaymentID,
			};
		}
        return copy;
    };

    // Expects the billinfo object from session.billing
    this.paymentMethodFromNewCard = function(billinfo, amount, hostedFieldsInterface, callback) {
        var copy = Object.create(models.paymentMethod);
        var min = 10000000;
        var max = 99999999;
        // Generate a hopefully unqiue id. Should only be for the frontend anyway
        copy.id = 'newcard-' + Math.floor(Math.random() * (max - min + 1)) + min;
        copy.method = 'creditcard';
        copy.payment_amount = parseFloat(amount);
        copy.first_name = billinfo.firstname;
        copy.last_name = billinfo.lastname;
        copy.address = billinfo.address1;
        copy.address2 = billinfo.address2;
        copy.company = billinfo.company;
        copy.country = billinfo.country;
        copy.city = billinfo.city;
        copy.state = billinfo.state;
        copy.zip = billinfo.zip;
        copy.billID = null;
        copy.billinfo = billinfo;
        copy.authNum = null;
        copy.hostedFieldsInterface = hostedFieldsInterface;
        copy.nonce = null;

        if ( checkout.payment.currentPaymentMethod.prepareData ) {
            checkout.payment.currentPaymentMethod.prepareData( copy, function() {
                callback( copy );
            } );
        }
        else {
            callback( copy );
        }
    };

    // Card is the payment method object from above
    // Expects the billinfo object from session.billing
    this.updateBillInfoOnNewCard = function(card, billinfo) {
        var copy = Object.create(card);

        copy.first_name = billinfo.firstname;
        copy.last_name = billinfo.lastname;
        copy.address = billinfo.address1;
        copy.address2 = billinfo.address2;
        copy.company = billinfo.company;
        copy.country = billinfo.country;
        copy.city = billinfo.city;
        copy.state = billinfo.state;
        copy.zip = billinfo.zip;
        copy.phone = billinfo.phone;
        copy.phone_alternate = billinfo.phone_alternate;
        copy.phone_fax = billinfo.phone_fax;
        copy.billID = null;
        copy.billinfo = billinfo;
        copy.hostedFieldsInterface = card.hostedFieldsInterface;

        return copy;
    };


    this.paymentMethodFromPaypalRequest = function(amount) {
        var copy = Object.create(models.paymentMethod);

        copy.method = 'paypalrequest';
        copy.payment_amount = parseFloat(amount);

        return copy;
    };
    
    this.paymentMethodFromAffirm = function(amount) {
        var copy = Object.create(models.paymentMethod);

        copy.method = 'affirm';
        copy.payment_amount = parseFloat(amount);

        return copy;
    };

    this.paymentMethodFromPaypal1 = function(amount) {
        var copy = Object.create(models.paymentMethod);

        copy.method = 'paypal';
        copy.payment_amount = parseFloat(amount);

        return copy;
    };

    this.paymentMethodFromPriorAuth = function(amount, data, billinfo) {
        var copy = Object.create(models.paymentMethod);

        copy.method = 'priorauth';
        copy.payment_amount = parseFloat(amount);
        copy.authNum = data.authNum;
        copy.cardType = data.cardType;
        copy.amtInput = data.amtInput;
        copy.first_name = billinfo.firstname;
        copy.last_name = billinfo.lastname;
        copy.address = billinfo.address1;
        copy.address2 = billinfo.address2;
        copy.company = billinfo.company;
        copy.country = billinfo.country;
        copy.city = billinfo.city;
        copy.state = billinfo.state;
        copy.zip = billinfo.zip;
        copy.phone = billinfo.phone;
        copy.phone_alternate = billinfo.phone_alternate;
        copy.phone_fax = billinfo.phone_fax;
        copy.billID = null;
        copy.billinfo = billinfo;
        delete copy['billID'];

        return copy;
    };

    this.paymentMethodFromWireTransfer = function(amount) {
        var copy = Object.create(models.paymentMethod);

        copy.method = 'wiretransfer';
        copy.payment_amount = parseFloat(amount);
        copy.fee = parseFloat(checkout.config.wireTransferFee);

        return copy;
    };

    this.paymentMethodFromOnAccount = function(amount) {
        var copy = Object.create(models.paymentMethod);

        copy.method = 'onaccount';
        copy.payment_amount = parseFloat(amount);

        return copy;
    };

    this.getBillinfoFromPaymentMethod = function(paymentMethod) {
        if(paymentMethod.address) {
            var session = checkout.session.get();
            return {
                address1: paymentMethod.address,
                address2: paymentMethod.address2,
                city: paymentMethod.city,
                company: paymentMethod.company,
                country: paymentMethod.country,
                email: session.email,
                firstname: paymentMethod.first_name,
                lastname: paymentMethod.last_name,
                phone: session.shipping.phone,
                phone_alternate: session.shipping.phone_alternate,
                phone_fax: paymentMethod.phone_fax,
                state: paymentMethod.state,
                zip: paymentMethod.zip
            }
        }
    };
};
